import type { RouteLocationNormalized } from 'vue-router';
import type { CustomerEnquetesResponses as ApiResponses } from '@/types/externals/obbsApi';

export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalized) => {
  const { getCustomerEnquete, fetchCustomerEnquete } = useCustomerEnquete();
  const serialNumber = to.params.serialNumber as string;

  await fetchCustomerEnquete(serialNumber);
  const customerEnquete: ApiResponses.CustomerEnquete | null = getCustomerEnquete();
  if (!customerEnquete) {
    return;
  }

  // notStarted: アンケート開始前 => 共通エラーページに遷移
  // inProgressUnanswered: アンケート開始後〜終了前＆未回答 => 回答ページ遷移
  // inProgressAnswered: アンケート開始後〜終了前＆回答済み => 回答済み表示
  // endedUnanswered: アンケート終了後&未回答 => 共通エラーページに遷移
  // endedAnswered: アンケート終了後&回答済み => 回答済み表示
  if (customerEnquete.status === 'notStarted') {
    throw createError({
      statusCode: 403,
      statusMessage: 'Forbidden',
      message: 'アンケート開始前です',
      fatal: true,
    });
  }
  if (customerEnquete.status === 'endedUnanswered') {
    throw createError({
      statusCode: 410,
      statusMessage: 'Gone',
      message: 'アンケート終了後かつ未回答です',
      fatal: true,
    });
  }
});
